import { View, ViewProps } from "react-native";
import React from "react";

interface SpacerProps extends ViewProps {
  children?: React.ReactNode;
  margin?: number;
}

const Spacer: React.FC<SpacerProps> = ({
  margin = 10,
  style,
  children,
  ...rest
}) => {
  return (
    <View style={[{ marginVertical: margin }, style]} {...rest}>
      {children}
    </View>
  );
};

export default Spacer;
